/*
 * @Author: liyxt
 * @Date: 2019-10-14 15:12:41
 * @LastEditors: liyxt
 * @LastEditTime: 2019-10-14 15:12:41
 * @Description: file content
 */
import React, { Component } from 'react';
import { Element } from 'react-scroll';

export default class ScrollElement extends Component {
    render() {
        return <Element className={`nc-scrollElement-wrap ${this.props.className}`} {...this.props} />;
    }
}
